import styled from 'styled-components';

export const TBody = styled.tbody``;
